import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { PortalApiService } from './portal-api.service';

export const authGuard: CanActivateFn = () => {
  const portalApi = inject(PortalApiService);
  const router = inject(Router);

  if (portalApi.session()) {
    return true;
  }

  return portalApi.loadSession().pipe(
    map(() => true),
    catchError(() => of(router.createUrlTree(['/login'])))
  );
};
